var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-range-picker',_vm._b({staticStyle:{"width":"100%"},attrs:{"allowClear":""},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'a-range-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }